// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media all and (min-width: 991px) {\n.btn-container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n}\n.new-assessment {\n  margin: 32px 0;\n}\n.help__ui-label {\n  font-weight: 400;\n  text-transform: capitalize;\n}", ""]);
// Exports
module.exports = exports;
